import { css } from "@emotion/react";
import styled from "@emotion/styled";

type SignUpButtonProps = {
  $isSignedUp: boolean;
};
export const Button = styled.button<SignUpButtonProps>`
  display: flex;
  flex: 1 0 0;
  gap: 10px;
  justify-content: center;
  align-items: center;

  padding-block: 8px;
  padding-inline: 12px;

  color: #ffffff;
  white-space: nowrap;

  border-radius: 2px;

  background: #4585ff;

  cursor: pointer;

  ${props =>
    props.$isSignedUp &&
    css`
      color: #666666;

      background: #e2e2e2;
    `}
`;

export const DottySpan = styled.span`
  ::after {
    content: "";

    display: inline-block;

    animation: dotty steps(1, end) 2s infinite;
  }

  @keyframes dotty {
    0% {
      content: "";
    }
    25% {
      content: ".";
    }
    50% {
      content: "..";
    }
    75% {
      content: "...";
    }
    100% {
      content: "";
    }
  }
`;
